import CallSubmissionFormContent from './call-submission-form-content'
import CallSubmissionFormTitle from './call-submission-form-title'

const CallSubmissionFormContainer = () => {
  return (
    <div>
      <CallSubmissionFormTitle />
      <CallSubmissionFormContent />
    </div>
  )
}

export default CallSubmissionFormContainer
